var _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarViewContractsGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_126_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 8,
    height: 7,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 8,
    height: 7,
    rx: 1,
    stroke: "#008C15",
    strokeWidth: 4,
    mask: "url(#path-1-inside-1_126_4058)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_126_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 4,
    width: 8,
    height: 7,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 4,
    width: 8,
    height: 7,
    rx: 1,
    stroke: "#008C15",
    strokeWidth: 4,
    mask: "url(#path-2-inside-2_126_4058)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_126_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 13,
    width: 8,
    height: 7,
    rx: 1
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 13,
    width: 8,
    height: 7,
    rx: 1,
    stroke: "#008C15",
    strokeWidth: 4,
    mask: "url(#path-3-inside-3_126_4058)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4_126_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 8,
    height: 7,
    rx: 1
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 8,
    height: 7,
    rx: 1,
    stroke: "#008C15",
    strokeWidth: 4,
    mask: "url(#path-4-inside-4_126_4058)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarViewContractsGreen);
export default __webpack_public_path__ + "static/media/CalendarViewContractsGreen.9340031c36efb72680be879ffa96e253.svg";
export { ForwardRef as ReactComponent };